import '@volvogroup-internal/dashboard/index.css';
import './globals.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.tsx';
import { isProfileEditCancelled, msalInstance } from './config/MsalAuthConfig';

async function bootstrap() {
  await msalInstance.initialize();

  let response = null;
  try {
    response = await msalInstance.handleRedirectPromise();
  } catch (error) {
    if (isProfileEditCancelled(error)) {
      // Keep the existing session; just drop the error fragment from the URL.
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    } else {
      console.error('handleRedirectPromise failed', error);
    }
  }

  if (response?.account) {
    msalInstance.setActiveAccount(response.account);
  } else {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

bootstrap();
